import React from "react";
import { BaseIconProps } from "../../types/styles";

const ScalpelIcon = ({
    id,
    className,
    size = 28,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-scalpel"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14" />
        </svg>
    );
};

export default ScalpelIcon;
